module.exports={close:"關閉",error:"錯誤",info:"資訊",success:"成功",warning:"警告"};